export var QuickActionType;
(function (QuickActionType) {
  QuickActionType["CANCEL_AN_ORDER"] = "CANCEL_AN_ORDER";
  QuickActionType["REPORT_DAMAGED_OR_MISSING_ITEMS"] = "REPORT_DAMAGED_OR_MISSING_ITEMS";
  QuickActionType["RETURN_ITEMS"] = "RETURN_ITEMS";
  QuickActionType["CONTACT_A_BRAND"] = "CONTACT_A_BRAND";
  QuickActionType["TRACK_AN_ORDER"] = "TRACK_AN_ORDER";
  QuickActionType["REQUEST_COMMISSION_CHANGE"] = "REQUEST_COMMISSION_CHANGE";
  QuickActionType["EDIT_ITEM_AVAILABILITY"] = "EDIT_ITEM_AVAILABILITY";
  QuickActionType["ACCEPT_AN_ORDER"] = "ACCEPT_AN_ORDER";
})(QuickActionType || (QuickActionType = {}));